/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Components_Upgrade_Plan_Modal_Features_EmbeddingsInputs */

const es_components_upgrade_plan_modal_features_embeddings = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_EmbeddingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} tokens para embeddings / mes`)
};

const en_components_upgrade_plan_modal_features_embeddings = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_EmbeddingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} tokens for embeddings / month`)
};

/**
* | output |
* | --- |
* | "{value} tokens for embeddings / month" |
*
* @param {Components_Upgrade_Plan_Modal_Features_EmbeddingsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_features_embeddings = /** @type {((inputs: Components_Upgrade_Plan_Modal_Features_EmbeddingsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Features_EmbeddingsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_features_embeddings(inputs)
	return en_components_upgrade_plan_modal_features_embeddings(inputs)
});
export { components_upgrade_plan_modal_features_embeddings as "components.upgrade_plan_modal.features.embeddings" }